var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.13753 4.29419H3.31402C2.8772 4.29419 2.45827 4.46772 2.1494 4.7766C1.84052 5.08548 1.66699 5.50441 1.66699 5.94124V13.353C1.66699 13.7898 1.84052 14.2087 2.1494 14.5176C2.45827 14.8265 2.8772 15 3.31402 15H10.7256C11.1625 15 11.5814 14.8265 11.8903 14.5176C12.1991 14.2087 12.3727 13.7898 12.3727 13.353V12.5294",
    stroke: "#4F5662",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5488 2.64714L14.0193 5.11771M15.1599 3.95242C15.4842 3.62808 15.6664 3.18818 15.6664 2.72949C15.6664 2.2708 15.4842 1.8309 15.1599 1.50656C14.8355 1.18221 14.3956 1 13.937 1C13.4783 1 13.0384 1.18221 12.714 1.50656L5.78418 8.41181V10.8824H8.25472L15.1599 3.95242Z",
    stroke: "#4F5662",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEdit);
export default __webpack_public_path__ + "static/media/ic-edit.c6f6e70392a49038c57a5491e9c8e0dd.svg";
export { ForwardRef as ReactComponent };